import React, { Component } from 'react'
import { Switch, Route, Redirect } from 'react-router-dom'

import UICulturalcreativeWorks from './culturalcreative-works-list'  /* 清單頁面 */
import UICulturalcreativeWorksDetails from './culturalcreative-works-details'
import UICulturalcreativeWorksModify from './culturalcreative-works-modify'

export default class CulturalcreativeWorks extends Component {
    render() {
        return (
            <Switch>
                <Route path='/culturalcreativeworks/works' component={UICulturalcreativeWorks} exact /> {/*exact = 路徑完全匹配*/}
                <Route path='/culturalcreativeworks/works/details' component={UICulturalcreativeWorksDetails} />
                <Route path='/culturalcreativeworks/works/modify' component={UICulturalcreativeWorksModify} />
                <Redirect to='/culturalcreativeworks/works' />
            </Switch>
        )
    }
}